/**
 * Телефон на экране: `+79141234567` → `+7 (914) 123-45-67` — везде один
 * вид, тот же, что даёт маска ввода (доработка M2-1 п. 2, fmtPh в макете).
 * Иностранный номер показывается как хранится. Нормализует номер сервер
 * (ТЗ M2 5.2) — здесь только вид.
 */
export function formatPhone(phone: string | null | undefined): string {
  if (!phone) return '';
  const m = phone.match(/^\+7(\d{3})(\d{3})(\d{2})(\d{2})$/);
  return m ? `+7 (${m[1]}) ${m[2]}-${m[3]}-${m[4]}` : phone;
}

/** Возраст словом: «10 лет», «2 года», «21 год». */
export function years(n: number): string {
  const a = Math.abs(n) % 100;
  const b = a % 10;
  const word = a > 10 && a < 20 ? 'лет' : b > 1 && b < 5 ? 'года' : b === 1 ? 'год' : 'лет';
  return `${n} ${word}`;
}
